import axios from 'axios';

const list = (data) => axios.get('/custom/course/list', data);
const save = (data) => axios.post('/custom/course/saveOrUpdate', data);
const del = (data) => axios.post('/custom/course/delete', data); //delete

export default {
  list,
  save,
  del,
}


